import { HashRouter as BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { getlevel, permission } from './Permissions';
import axios from "axios";
import Login from "./Components/Login";
import Logo from "./Components/logo";
import Forgot_Password from "./Components/Forgot_Password";

import Companies from "./Components/Company/Companies";
import Create_com from "./Components/Company/Create_com";
import Edit_company from "./Components/Company/Edit_company";

import Users from "./Components/Users/Users";
import Create_user from "./Components/Users/Create_user";
import Edit_User from "./Components/Users/Edit_User";

import Bound from "./Components/Bound/Bound";
import Configurations from "./Components/Bound/configurations";
import Edit_Configuration from "./Components/Bound/Edit_Configuration";

import In_Bound from "./Components/In_Bound/In_Bound";
import Add_In_Bound from "./Components/In_Bound/Add_In_Bound";
import Edit_In_Bound from "./Components/In_Bound/Edit_In_Bound";
import In_Bound_Details from "./Components/In_Bound/In_Bound_Details";
import Manual_File_Upload from "./Components/In_Bound/Manual_File_Upload";
import In_Log_files from "./Components/In_Bound/In_Log_files";

import Export_Details from './Components/Out_Bound/Out_Bound_Details';
import Add_Export_Details from './Components/Out_Bound/Add_Out_Bound';
import Edit_Export_Details from './Components/Out_Bound/Edit_Out_Bound';
import Tables from './Components/Out_Bound/Out_Bound';
import Conditionstable from './Components/Out_Bound/Conditionstable';
import Linkedconditions from './Components/Out_Bound/Linkedconditions';
import MergeTables from './Components/Out_Bound/MergeTables';
import Fieldsmapping from './Components/Out_Bound/Fieldsmapping';
import Out_Log_files from "./Components/Out_Bound/Out_Log_files";
import API_In_Bound from "./Components/In_Bound/API_In_Bound";
import OutBound_Result from "./Components/Out_Bound/OutBound_Result";
import Mapping from "./Components/Out_Bound/Mapping";
import Config from "./Components/Out_Bound/Config";

axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

const ProtectedRoute = ({ allowedRoles, element }) => {
  const userRole = getlevel();
  return allowedRoles.includes(userRole) ? element : <Navigate to="/" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/logo" element={<Logo />} />
        <Route path="/forgot_password" element={<Forgot_Password />} />

        {/* ---------------------------------------Company ------------------------------------------------*/}

        <Route path="/company" element={<ProtectedRoute allowedRoles={permission.Companies} element={<Companies />} />} />
        <Route path="/company/add" element={<ProtectedRoute allowedRoles={permission.Companies} element={<Create_com />} />} />
        <Route path="/company/edit/:id" element={<ProtectedRoute allowedRoles={permission.Companies} element={<Edit_company />} />} />
        {/* <Route path="/company/add" element={<Create_com />} />
        <Route path="/company/edit/:id" element={<Edit_company />} /> */}

        {/* ---------------------------------------Users ------------------------------------------------*/}
        <Route path="/company/users/:id" element={<ProtectedRoute allowedRoles={permission.Users} element={<Users />} />} />
        <Route path="/user/add/:id" element={<ProtectedRoute allowedRoles={permission.Users} element={<Create_user />} />} />
        <Route path="/user/edit/:com_id/:id" element={<ProtectedRoute allowedRoles={permission.Users} element={<Edit_User />} />} />


        {/* --------------------------------------- Bound ------------------------------------------------*/}
        <Route path="/integ/:id" element={<ProtectedRoute allowedRoles={permission.Integrations} element={<Bound />} />} />
        <Route path="/integ/add/:id" element={<ProtectedRoute allowedRoles={permission.Integrations} element={<Configurations />} />} />
        <Route path="/bound/edit/:id/:E_id" element={<ProtectedRoute allowedRoles={permission.Integrations} element={<Edit_Configuration />} />} />

        {/* ----------------------------------------In Bound ------------------------------------------------*/}
        <Route path="/in_bound_details/:id/:int_id" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<In_Bound_Details />} />} />
        <Route path="/in_bound/add/:id/:int_id" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<Add_In_Bound />} />} />
        <Route path="/in_bound/edit/:id/:int_id/:E_id" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<Edit_In_Bound />} />} />
        <Route path="/in_bound/:id/:int_id/:ib_id" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<In_Bound />} />} />
        <Route path="/in_bound/manual/:id/:int_id" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<Manual_File_Upload />} />} />
        <Route path="/in_bound/api/:id/:int_id" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<API_In_Bound />} />} />
        <Route path="/in_bound/log/:id/:int_id/:sample" element={<ProtectedRoute allowedRoles={permission.In_bound} element={<In_Log_files />} />} />

        {/* ---------------------------------------Out Bound ------------------------------------------------*/}
        <Route path="/out_bound_details/:id/:int_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Export_Details />} />} />
        <Route path="/out_bound/add/:id/:int_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Add_Export_Details />} />} />
        <Route path="/out_bound/edit/:id/:int_id/:E_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Edit_Export_Details />} />} />
        <Route path="/out_bound/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Tables />} />} />
        <Route path="/out_bound/output/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<OutBound_Result />} />} />
        <Route path="/out_bound/conditions/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Conditionstable />} />} />
        <Route path="/out_bound/linked/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Linkedconditions />} />} />
        <Route path="/out_bound/MergeTables/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={< MergeTables />} />} />
        <Route path="/out_bound/config/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={< Config />} />} />
        <Route path="/out_bound/fieldmapping/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Fieldsmapping />} />} />
        <Route path="/out_bound/mapping/:id/:int_id/:Ex_id" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Mapping />} />} />
        <Route path="/out_bound/log/:id/:int_id/:value" element={<ProtectedRoute allowedRoles={permission.Out_bound} element={<Out_Log_files />} />} />

      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
